import { assetBySymbol } from '@/onchain/assets';

// Equity token image mapping for tokenized equities not in the asset registry
export const EQUITY_IMAGE_MAP: Record<string, string> = {
  tNVDA: '/equities/Nvidia.svg',
  tTSLA: '/equities/Tesla.svg',
  tAAPL: '/equities/Apple.svg',
  tAPPL: '/equities/Apple.svg', // Handle alternate spelling
  tAMZN: '/equities/Meta.svg', // Placeholder until Amazon.svg is available
  tGOOGL: '/equities/Google.svg',
  tAVGO: '/equities/Broadcom.svg',
  tMETA: '/equities/Meta.svg',
  tMSFT: '/equities/Microsoft.svg',
};

/**
 * Get image URL for a token symbol.
 * Checks the asset registry first, then falls back to equity token mapping.
 */
export function getTokenImageUrl(symbol: string): string {
  // First check the asset registry
  const asset = assetBySymbol(symbol);
  if (asset?.imageUrl) {
    return asset.imageUrl;
  }
  // Then check equity token mapping
  if (EQUITY_IMAGE_MAP[symbol]) {
    return EQUITY_IMAGE_MAP[symbol];
  }
  // Fallback
  return '/tcoin.png';
}
